import { DSIHtml, PopoverIcon } from 'shared'

export const DataTransferPopover = ({ name, city, street, zip }) =>
  <PopoverIcon
    placement='top'
    popoverId='tooltip-for-data-transfer'
    container={document.getElementsByClassName('generic-popover-constraints')[0]}
  >
    <div className="popover-body">
      <DSIHtml value={I18n.t('shared.data_transfer_popover_html', { name, city: city || '', street: street || '', zip: zip || '' })} />
    </div>
  </PopoverIcon>
